module.exports = __webpack_public_path__ + "img/Brian_King@1x.23d6346d.webp";